<template>
	<ValidationObserver v-slot="{ passes, invalid }" class="account-form" tag="form" @submit.prevent>
		<div class="form-group">
			<TextInput
				v-model.trim="email"
				:disabled="loading"
				:label="$tc('labels.coachEmailLabel')"
				name="email"
				:placeholder="$tc('labels.coachEmailPlaceholder')"
				rules="required|email"
			/>
		</div>

		<div class="mt-75 text-center">
			<button
				v-loading="loading"
				:disabled="loading || invalid"
				class="button-light-blue"
				@click="passes(inviteTeamAdmin)"
			>
				{{ $tc('actions.send') }}
			</button>
		</div>
	</ValidationObserver>
</template>

<script>
import { mapActions } from 'vuex'
import { ValidationObserver } from 'vee-validate'
import { TextInput } from '~/components/interface'

export default {
	name: 'InviteMemberForm',
	components: {
		ValidationObserver,
		TextInput
	},
	props: {
		teamId: {
			type: String,
			required: true
		}
	},
	data () {
		return {
			loading: false,
			email: ''
		}
	},
	methods: {
		...mapActions({ inviteAdminAction: 'teams/inviteTeamAdmin' }),

		async inviteTeamAdmin () {
			this.loading = true

			try {
				await this.inviteAdminAction({ teamId: this.teamId, email: this.email })

				this.$toast.success(this.$tc('successMessages.inviteSuccessfullySend'))
			} catch (error) {
				this.$toast.error(this.$tc('errors.failedCreateCoach'))
				this.$log.error('Failed add new coach', error)
			}

			this.loading = false
			this.$emit('success')
		}
	}
}
</script>
